import { render } from "./IconInstagram.vue?vue&type=template&id=54a41469"
import script from "./IconInstagram.vue?vue&type=script&lang=js"
export * from "./IconInstagram.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\suph-annuaire-plugin\\suph-card-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__